import React, {useState, useEffect} from 'react';
// reactstrap components
import {
    Collapse,
    Card,Badge,Spinner,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Container,
  } from "reactstrap";
  import ReactTable from "components/ReactTable/ReactTable.js";
  
function Mlisting(props) {

  const [list , setList ] = useState([])

  useEffect(() => {
    console.log("I AM IN MLISTING")
    setList(props.filterbyt.value === "" ? props.mylist : props.mylist.filter(m => m.ac.categoryCode === props.filterbyt.value) )
  },[props.filterbyt, props.mylist])


    const returnvlist = () => {
        try{
              return (
                <Card>
                <CardBody>
                  <ReactTable
                    data= {list}
                    columns={[
                      {
                          Header: "img",
                          accessor: d =>  <center><img alt="..." width={"40px"} src={`${d.ac.blogo}`} style={{ cursor : "pointer"}} /> </center>,
                        },
                        {
                            Header: "ListID",
                            accessor: d =>  d.ac.luid,
                          },
                      {
                        Header: "C.Name",
                        accessor: d =>  d.ac.category.en + " " + d.ac.category.ar ,
                      },
                     
                      {
                        Header: "Brand",
                        accessor: d => d.ac.bname.en + " " + d.ac.bname.ar,
                      },
                      {
                          Header: "Model",
                          accessor: d =>  d.ac.mname.en + " " + d.ac.mname.ar,
                        },
                    {
                            Header: "Daily",
                            accessor: d =>  d.ac.daily.amt,
                    },
                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                      },
                    ]}
                    /*
                        You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                      */
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
              )  
        }catch(e){
          //  console.log(e)
        }
       }
    

    return (
       <div>
            <Row>
                <Col>
                <h6>My Listing<i className="fa fa-filter" aria-hidden="true" style={{paddingLeft : 20, cursor : "pointer", color : "blue"}} onClick={props.toggle}></i>  <span style={{float : "right"}}> 
                                        
                                        <i className="fa fa-exchange" aria-hidden="true" style={{paddingRight : 20, cursor : "pointer"}} onClick={x => props.setListswap(!props.listswap)}></i>{' '}
                                        <i className="fa fa-refresh" aria-hidden="true" style={{float : "right", cursor : "pointer", marginTop : 2}} onClick={f => {}}/></span></h6>
                    <Collapse isOpen={props.isOpen}>
                    <Card>
                      <CardBody>
                      {props.filtercontrol()}
                      </CardBody>
                    </Card>
                  </Collapse>
                </Col>
            </Row>
            <div className="content">
               {returnvlist()}
              </div>     
        </div>
            
      
    );
}

export default Mlisting;